<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'modals.add_fodder' | translate }}
    v-card-content
      v-text-field.mb-3(
        :focus="true"
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        @input="clearError('name')"
        v-model="form.name")
      v-select.mb-3(
        :label="$t('base.ingredient_type')"
        returnObject
        :options="ingredientTypes"
        :hint="errorMessage('ingredient_type')"
        :invalid="!!errorMessage('ingredient_type')"
        @input="clearError('ingredient_type')"
        v-model="form.ingredient_type")
      v-select.mb-3(
        :label="$t('base.stock')"
        returnObject
        :options="filteredStocks"
        :hint="errorMessage('stock')"
        :invalid="!!errorMessage('stock')"
        @input="clearError('stock')"
        v-model="form.stock")
      .toogle-wrap
        ui-toggle-unit(
          :tolerancePercent="form.tolerance_percent"
          :toleranceUnit="form.tolerance_unit"
          :toleranceKg="form.tolerance_kg"
          @update="onToleranceUpdate"
        )
      v-switch.mb-3(
        :label="$t('base.ignore_in_reports')"
        v-model="form.ignored_in_report")
      v-switch(
        :label="$t('base.auto_load')"
        v-model="form.auto_load")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="onCreate")
        | {{ 'base.add' | translate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import UiToggleUnit from '@/components/ui/ui-toggle-unit/UiToggleUnit.vue'
export default {
  name: 'CreateFodderModal',
  components: {
    UiToggleUnit
  },
  data: () => ({
    form: {
      name: null,
      ingredient_type: null,
      stock: null,
      dry_matter: 0,
      is_animalfeed: true,
      ignored_in_report: false,
      auto_load: false,
      tolerance_kg: 0,
      tolerance_percent: 97,
      tolerance_unit: 'percent',
    },
    errors: {
      name: null,
      stock: null,
      ingredient_type: null
    },
    loading: false
  }),

  computed: {
    ...mapGetters('ingredienttypes', [
      'ingredientTypes'
    ]),

    ...mapGetters('stocks', [
      'stocks'
    ]),
    filteredStocks () {
      return this.stocks
        .filter(item => (item.farm === null && (item.company && item.company.id) === +this.$route.params.company_id) ||
          (item.farm && item.farm.id) === +this.$route.params.farm_id)
    },
  },
  mixins: [formErrorsMixin],
  methods: {
    ...mapActions('ingredients', [
      'createIngredient',
      'loadIngredients'
    ]),

    ...mapActions('ingredienttypes', [
      'loadIngredientTypes'
    ]),

    ...mapActions('stocks', [
      'loadStocks'
    ]),
    async onCreate () {
      const payload = {
        ...this.form,
        farm: this.$route.params.farm_id
      }
      if (!this.checkValidData()) return
      this.loading = true
      const { errors } = await this.createIngredient(payload)
      await this.loadIngredients({ farm: this.$route.params.farm_id })

      if (!errors) {
        this.$root.$emit('UpdateFodderTable')
        this.$emit('close')
      } else {
        this.errors = errors

        if (this.errors.non_field_errors) {
          this.errors.ingredient_type = this.errors.ingredient_type = ['5']
        }
      }
      this.loading = false
    },
    checkValidData () {
      let valid = true
      if (!this.form.name) {
        this.errors.name = this.errors.name = ['3']
        valid = false
      } else if (this.form.name.length >= 100) {
        this.errors.name = this.errors.name = ['6', 100]
        valid = false
      }
      if (!this.form.stock) {
        this.errors.stock = this.errors.stock = ['3']
        valid = false
      }
      if (!this.form.ingredient_type) {
        this.errors.ingredient_type = this.errors.ingredient_type = ['3']
        valid = false
      }

      return valid
    },
    onToleranceUpdate (payload) {
      this.form.tolerance_kg = payload.tolerance_kg
      this.form.tolerance_percent = payload.tolerance_percent
      this.form.tolerance_unit = payload.tolerance_unit
    }
  },

  mounted () {
    this.loadIngredientTypes({ limit: 10000 })
    const company = +this.$route.params.company_id
    const farm = +this.$route.params.farm_id
    this.loadStocks({ company, farm })
  }
}
</script>
